export const packages = [
  {
    id: 1,
    title: "Bangkok & Pattaya Discovery",
    slug: "bangkok-pattaya-discovery",
    destination: "Thailand",
    duration: "5 Days",
    rating: 4.5,
    price: "35,000",
    image:
      "https://images.unsplash.com/photo-1528181304800-259b08848526?w=600&h=400&fit=crop",
    hint: "thailand beach temple golden",
    isWishlisted: false,
    agentId: 1,
    groupSize: { min: 2, max: 8 },
    category: "Adventure",
  },
  {
    id: 2,
    title: "Enchanting Bali Getaway",
    slug: "enchanting-bali-getaway",
    destination: "Indonesia",
    duration: "7 Days",
    rating: 4.8,
    price: "45,000",
    image:
      "https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?w=600&h=400&fit=crop",
    hint: "bali temple rice terraces sunset",
    isWishlisted: true,
    agentId: 2,
    groupSize: { min: 2, max: 12 },
    category: "Culture & Relaxation",
  },
  {
    id: 3,
    title: "Highlights of Vietnam",
    slug: "highlights-of-vietnam",
    destination: "Vietnam",
    duration: "6 Days",
    rating: 4.6,
    price: "42,000",
    image:
      "https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=600&h=400&fit=crop",
    hint: "vietnam halong bay mountains landscape",
    isWishlisted: false,
    agentId: 3,
    groupSize: { min: 4, max: 16 },
    category: "Cultural Heritage",
  },
  {
    id: 4,
    title: "Singapore City Spectacular",
    slug: "singapore-city-spectacular",
    destination: "Singapore",
    duration: "4 Days",
    rating: 4.7,
    price: "55,000",
    image:
      "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=600&h=400&fit=crop",
    hint: "singapore skyline marina bay modern",
    isWishlisted: false,
    agentId: 4,
    groupSize: { min: 1, max: 6 },
    category: "City Break",
  },
  {
    id: 5,
    title: "Malaysian Marvels",
    slug: "malaysian-marvels",
    destination: "Malaysia",
    duration: "6 Days",
    rating: 4.4,
    price: "48,000",
    image:
      "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=600&h=400&fit=crop",
    hint: "malaysia kuala lumpur towers city",
    isWishlisted: false,
    agentId: 2,
    groupSize: { min: 2, max: 10 },
    category: "Cultural Heritage",
  },
  {
    id: 6,
    title: "Colors of Sri Lanka",
    slug: "colors-of-sri-lanka",
    destination: "Sri Lanka",
    duration: "8 Days",
    rating: 4.9,
    price: "60,000",
    image:
      "https://images.unsplash.com/photo-1566198411923-6b89ffdc657a?w=600&h=400&fit=crop",
    hint: "sri lanka tea plantation green mountains",
    isWishlisted: false,
    agentId: 4,
    groupSize: { min: 2, max: 14 },
    category: "Nature & Wildlife",
  },
  {
    id: 7,
    title: "Philippine Island Hopping",
    slug: "philippine-island-hopping",
    destination: "Philippines",
    duration: "10 Days",
    rating: 4.8,
    price: "75,000",
    image:
      "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?w=600&h=400&fit=crop",
    hint: "philippines palawan boats crystal clear water",
    isWishlisted: false,
    agentId: 3,
    groupSize: { min: 4, max: 20 },
    category: "Adventure",
  },
  {
    id: 8,
    title: "Laos Heritage Trail",
    slug: "laos-heritage-trail",
    destination: "Laos",
    duration: "5 Days",
    rating: 4.5,
    price: "40,000",
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&h=400&fit=crop",
    hint: "laos luang prabang temple monks",
    isWishlisted: false,
    agentId: 1,
    groupSize: { min: 2, max: 8 },
    category: "Cultural Heritage",
  },
  {
    id: 9,
    title: "Romantic Maldives Escape",
    slug: "romantic-maldives-escape",
    destination: "Maldives",
    duration: "5 Days",
    rating: 4.9,
    price: "120,000",
    image:
      "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=600&h=400&fit=crop",
    hint: "maldives overwater villa turquoise water",
    isWishlisted: false,
    agentId: 2,
    groupSize: { min: 2, max: 4 },
    category: "Luxury & Romance",
  },
  {
    id: 10,
    title: "Bhutan Kingdom Discovery",
    slug: "bhutan-kingdom-discovery",
    destination: "Bhutan",
    duration: "7 Days",
    rating: 4.7,
    price: "95,000",
    image:
      "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=600&h=400&fit=crop",
    hint: "bhutan monastery mountains prayer flags",
    isWishlisted: false,
    agentId: 3,
    groupSize: { min: 4, max: 12 },
    category: "Cultural Heritage",
  },
  {
    id: 11,
    title: "Myanmar Golden Pagodas",
    slug: "myanmar-golden-pagodas",
    destination: "Myanmar",
    duration: "8 Days",
    rating: 4.6,
    price: "65,000",
    image:
      "https://images.unsplash.com/photo-1513415564515-763d91423bdd?w=600&h=400&fit=crop",
    hint: "myanmar bagan temples golden sunset",
    isWishlisted: false,
    agentId: 1,
    groupSize: { min: 2, max: 14 },
    category: "Cultural Heritage",
  },
  {
    id: 12,
    title: "Cambodia Angkor Wonder",
    slug: "cambodia-angkor-wonder",
    destination: "Cambodia",
    duration: "6 Days",
    rating: 4.8,
    price: "52,000",
    image:
      "https://images.unsplash.com/photo-1563492065-69ad59d38ae8?w=600&h=400&fit=crop",
    hint: "cambodia angkor wat temple sunrise",
    isWishlisted: false,
    agentId: 4,
    groupSize: { min: 2, max: 16 },
    category: "Cultural Heritage",
  },
  {
    id: 13,
    title: "Japan Cherry Blossom",
    slug: "japan-cherry-blossom",
    destination: "Japan",
    duration: "10 Days",
    rating: 4.9,
    price: "150,000",
    image:
      "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=600&h=400&fit=crop",
    hint: "japan cherry blossoms mount fuji temple",
    isWishlisted: true,
    agentId: 2,
    groupSize: { min: 2, max: 8 },
    category: "Cultural Heritage",
  },
  {
    id: 14,
    title: "Korean Culture & K-Pop",
    slug: "korean-culture-kpop",
    destination: "South Korea",
    duration: "7 Days",
    rating: 4.6,
    price: "85,000",
    image:
      "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=600&h=400&fit=crop",
    hint: "korea seoul city skyline modern night",
    isWishlisted: false,
    agentId: 3,
    groupSize: { min: 2, max: 10 },
    category: "City Break",
  },
  {
    id: 15,
    title: "Nepal Himalayan Trek",
    slug: "nepal-himalayan-trek",
    destination: "Nepal",
    duration: "12 Days",
    rating: 4.7,
    price: "78,000",
    image:
      "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=600&h=400&fit=crop",
    hint: "nepal himalayas mountains trekking adventure",
    isWishlisted: false,
    agentId: 1,
    groupSize: { min: 4, max: 12 },
    category: "Adventure",
  },
  {
    id: 16,
    title: "Brunei Sultan's Legacy",
    slug: "brunei-sultan-legacy",
    destination: "Brunei",
    duration: "4 Days",
    rating: 4.3,
    price: "45,000",
    image:
      "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600&h=400&fit=crop",
    hint: "brunei mosque golden dome islamic",
    isWishlisted: false,
    agentId: 4,
    groupSize: { min: 2, max: 8 },
    category: "Cultural Heritage",
  },
  {
    id: 17,
    title: "Hong Kong Skyline & Dim Sum",
    slug: "hong-kong-skyline-dimsum",
    destination: "Hong Kong",
    duration: "5 Days",
    rating: 4.5,
    price: "68,000",
    image:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop",
    hint: "hong kong skyline victoria harbour night",
    isWishlisted: false,
    agentId: 2,
    groupSize: { min: 1, max: 8 },
    category: "City Break",
  },
  {
    id: 18,
    title: "Taiwan Night Markets",
    slug: "taiwan-night-markets",
    destination: "Taiwan",
    duration: "6 Days",
    rating: 4.4,
    price: "58,000",
    image:
      "https://images.unsplash.com/photo-1494390248081-4e521a5940db?w=600&h=400&fit=crop",
    hint: "taiwan taipei 101 mountain food",
    isWishlisted: false,
    agentId: 3,
    groupSize: { min: 2, max: 10 },
    category: "Cultural Heritage",
  },
  {
    id: 19,
    title: "Macau Casino & Heritage",
    slug: "macau-casino-heritage",
    destination: "Macau",
    duration: "3 Days",
    rating: 4.2,
    price: "42,000",
    image:
      "https://images.unsplash.com/photo-1544274904-42e4b6558f7f?w=600&h=400&fit=crop",
    hint: "macau casino lights heritage architecture",
    isWishlisted: false,
    agentId: 1,
    groupSize: { min: 2, max: 6 },
    category: "City Break",
  },
  {
    id: 20,
    title: "Tibet Spiritual Journey",
    slug: "tibet-spiritual-journey",
    destination: "Tibet",
    duration: "9 Days",
    rating: 4.8,
    price: "110,000",
    image:
      "https://images.unsplash.com/photo-1570197788417-0e82375c9371?w=600&h=400&fit=crop",
    hint: "tibet potala palace mountains monks",
    isWishlisted: true,
    agentId: 4,
    groupSize: { min: 4, max: 8 },
    category: "Cultural Heritage",
  },
  {
    id: 21,
    title: "Luxury European Grand Tour",
    slug: "luxury-european-grand-tour",
    destination: "Europe",
    duration: "15 Days",
    rating: 4.9,
    price: "450,000",
    image:
      "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=600&h=400&fit=crop",
    hint: "europe luxury travel paris rome venice",
    isWishlisted: false,
    agentId: 1,
    groupSize: { min: 2, max: 6 },
    category: "Luxury & Romance",
  },
  {
    id: 22,
    title: "Osaka & Kyoto Cultural Journey",
    slug: "osaka-kyoto-cultural-journey",
    destination: "Japan",
    duration: "8 Days",
    rating: 4.8,
    price: "320,000",
    image:
      "https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=600&h=400&fit=crop",
    hint: "japan osaka kyoto temple culture",
    isWishlisted: false,
    agentId: 4,
    groupSize: { min: 2, max: 10 },
    category: "Cultural Heritage",
  },
];

export const destinations = [
  {
    name: "All",
    image:
      "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=100&h=100&fit=crop",
    hint: "world travel globe",
  },
  {
    name: "Thailand",
    image:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=100&h=100&fit=crop",
    hint: "thailand temple golden",
  },
  {
    name: "Vietnam",
    image:
      "https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=100&h=100&fit=crop",
    hint: "vietnam halong bay",
  },
  {
    name: "Singapore",
    image:
      "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=100&h=100&fit=crop",
    hint: "singapore marina bay",
  },
  {
    name: "Malaysia",
    image:
      "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=100&h=100&fit=crop",
    hint: "malaysia petronas towers",
  },
  {
    name: "Indonesia",
    image:
      "https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?w=100&h=100&fit=crop",
    hint: "indonesia bali temple",
  },
  {
    name: "Philippines",
    image:
      "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?w=100&h=100&fit=crop",
    hint: "philippines palawan island",
  },
  {
    name: "Sri Lanka",
    image:
      "https://images.unsplash.com/photo-1566198411923-6b89ffdc657a?w=100&h=100&fit=crop",
    hint: "sri lanka tea plantation",
  },
  {
    name: "Laos",
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=100&h=100&fit=crop",
    hint: "laos luang prabang temple",
  },
  {
    name: "Maldives",
    image:
      "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=100&h=100&fit=crop",
    hint: "maldives overwater villa",
  },
  {
    name: "Japan",
    image:
      "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=100&h=100&fit=crop",
    hint: "japan cherry blossoms",
  },
  {
    name: "South Korea",
    image:
      "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=100&h=100&fit=crop",
    hint: "korea seoul skyline",
  },
  {
    name: "Nepal",
    image:
      "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=100&h=100&fit=crop",
    hint: "nepal himalaya mountains",
  },
  {
    name: "Bhutan",
    image:
      "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=100&h=100&fit=crop",
    hint: "bhutan monastery",
  },
  {
    name: "Myanmar",
    image:
      "https://images.unsplash.com/photo-1513415564515-763d91423bdd?w=100&h=100&fit=crop",
    hint: "myanmar bagan temples",
  },
  {
    name: "Cambodia",
    image:
      "https://images.unsplash.com/photo-1563492065-69ad59d38ae8?w=100&h=100&fit=crop",
    hint: "cambodia angkor wat",
  },
  {
    name: "Hong Kong",
    image:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=100&h=100&fit=crop",
    hint: "hong kong skyline",
  },
  {
    name: "Taiwan",
    image:
      "https://images.unsplash.com/photo-1494390248081-4e521a5940db?w=100&h=100&fit=crop",
    hint: "taiwan taipei mountains",
  },
  {
    name: "Macau",
    image:
      "https://images.unsplash.com/photo-1544274904-42e4b6558f7f?w=100&h=100&fit=crop",
    hint: "macau casino heritage",
  },
  {
    name: "Tibet",
    image:
      "https://images.unsplash.com/photo-1570197788417-0e82375c9371?w=100&h=100&fit=crop",
    hint: "tibet potala palace",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Anika Sharma",
    avatar:
      "https://images.unsplash.com/photo-1494790108755-2616b612b47c?w=100&h=100&fit=crop",
    hint: "woman smiling travel happy",
    quote:
      "Booking through Triploko was a breeze! We got an incredible deal for our Bali trip directly from the local operators. The rice terraces were absolutely breathtaking!",
  },
  {
    id: 2,
    name: "Rohan Patel",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    hint: "man travel adventure backpack",
    quote:
      "The transparency is what I loved. I knew exactly who I was booking with in Thailand. The package was well-planned and the floating markets experience was unforgettable. Highly recommended!",
  },
  {
    id: 3,
    name: "Priya Singh",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    hint: "woman family beach vacation",
    quote:
      "Found the perfect family package to Singapore. The ability to chat with the DMC before booking was a fantastic feature. The kids loved Universal Studios and Gardens by the Bay!",
  },
  {
    id: 4,
    name: "Vikram Mehta",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
    hint: "man business professional",
    quote:
      "As a frequent business traveler, I appreciate the seamless experience. The Vietnam package exceeded expectations - Ha Long Bay cruise was spectacular and the local guides were knowledgeable.",
  },
  {
    id: 5,
    name: "Kavya Reddy",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop",
    hint: "woman solo travel adventure",
    quote:
      "Solo traveled to Japan through Triploko. The cherry blossom season package was perfectly timed, and I felt safe throughout. Mount Fuji views were once-in-a-lifetime!",
  },
];

export const agents = [
  {
    id: 1,
    name: "Siam Adventures",
    logo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
    hint: "thailand travel company logo",
    rating: 4.8,
    reviews: 143,
    specialty: "Thailand, Laos, Myanmar & Nepal",
    phone: "+66 2 123 4567",
    email: "contact@siamadventures.com",
    website: "siamadventures.com",
    description:
      "Siam Adventures is a premier tour operator in Thailand, offering unforgettable experiences from the bustling streets of Bangkok to the serene temples of Chiang Mai. We pride ourselves on authentic local guides and personalized service.",
    // Add missing properties
    company: "Siam Adventures Co., Ltd.",
    image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
    location: "Bangkok, Thailand",
    totalBookings: 1247,
    successRate: "98%",
    responseTime: "< 2 hours",
    memberSince: "Jan 2020",
    status: "active",
  },
  {
    id: 2,
    name: "Bali Horizons",
    logo: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=100&h=100&fit=crop",
    hint: "indonesia bali travel company",
    rating: 4.9,
    reviews: 287,
    specialty: "Indonesia, Malaysia, Maldives & Hong Kong",
    phone: "+62 361 987 654",
    email: "info@balihorizons.com",
    website: "balihorizons.com",
    description:
      "Explore the magic of the Indonesian archipelago with Bali Horizons. From stunning beaches to ancient temples, our expert team curates journeys that capture the heart and soul of Southeast Asia.",
    // Add missing properties
    company: "Bali Horizons Travel",
    image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=100&h=100&fit=crop",
    location: "Denpasar, Bali, Indonesia",
    totalBookings: 2156,
    successRate: "99%",
    responseTime: "< 1 hour",
    memberSince: "Mar 2019",
    status: "active",
  },
  {
    id: 3,
    name: "Indochina Trails",
    logo: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=100&h=100&fit=crop",
    hint: "vietnam laos travel company",
    rating: 4.7,
    reviews: 195,
    specialty: "Vietnam, Philippines, Bhutan, South Korea & Taiwan",
    phone: "+84 24 555 8888",
    email: "support@indochinatrails.com",
    website: "indochinatrails.com",
    description:
      "Discover the rich history and vibrant cultures of Vietnam and the Philippines with Indochina Trails. Our tours are designed to be immersive, educational, and breathtakingly beautiful.",
    // Add missing properties
    company: "Indochina Trails Ltd.",
    image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=100&h=100&fit=crop",
    location: "Hanoi, Vietnam",
    totalBookings: 1893,
    successRate: "97%",
    responseTime: "< 3 hours",
    memberSince: "Jun 2021",
    status: "active",
  },
  {
    id: 4,
    name: "Lanka Pearl Tours",
    logo: "https://images.unsplash.com/photo-1566198411923-6b89ffdc657a?w=100&h=100&fit=crop",
    hint: "sri lanka travel company",
    rating: 4.9,
    reviews: 156,
    specialty: "Sri Lanka, Singapore, Cambodia, Japan, Brunei & Tibet",
    phone: "+94 11 222 3333",
    email: "bookings@lankapearl.com",
    website: "lankapearl.com",
    description:
      "Experience the teardrop island of Sri Lanka like never before. Lanka Pearl Tours offers bespoke itineraries covering ancient cities, lush tea plantations, and stunning coastlines.",
    // Add missing properties
    company: "Lanka Pearl Tours & Travels",
    image: "https://images.unsplash.com/photo-1566198411923-6b89ffdc657a?w=100&h=100&fit=crop",
    location: "Colombo, Sri Lanka",
    totalBookings: 1678,
    successRate: "96%",
    responseTime: "< 4 hours",
    memberSince: "Sep 2022",
    status: "active",
  },
];

export type BookingStatus = "confirmed" | "pending" | "cancelled" | "completed";

export const mockBookings = [
  {
    id: "BK001",
    packageId: 2, // Enchanting Bali Getaway
    userId: "priya@example.com",
    status: "confirmed" as BookingStatus,
    bookingDate: "2024-01-15",
    travelDate: "2024-03-15",
    travelers: 2,
    totalAmount: 90000,
    paymentStatus: "paid",
    confirmation: "RSE-BLI-2024-001",
  },
  {
    id: "BK002",
    packageId: 13, // Japan Cherry Blossom
    userId: "priya@example.com",
    status: "pending" as BookingStatus,
    bookingDate: "2024-01-20",
    travelDate: "2024-04-10",
    travelers: 2,
    totalAmount: 300000,
    paymentStatus: "pending",
    confirmation: "RSE-JPN-2024-002",
  },
  {
    id: "BK003",
    packageId: 1, // Bangkok & Pattaya Discovery
    userId: "priya@example.com",
    status: "completed" as BookingStatus,
    bookingDate: "2023-11-10",
    travelDate: "2023-12-20",
    travelers: 4,
    totalAmount: 140000,
    paymentStatus: "paid",
    confirmation: "RSE-THA-2023-003",
    review: {
      rating: 5,
      comment:
        "Amazing trip! The local guides were fantastic and the itinerary was perfectly planned.",
      date: "2023-12-28",
    },
  },
  {
    id: "BK004",
    packageId: 4, // Singapore City Spectacular
    userId: "priya@example.com",
    status: "completed" as BookingStatus,
    bookingDate: "2023-08-15",
    travelDate: "2023-09-10",
    travelers: 2,
    totalAmount: 110000,
    paymentStatus: "paid",
    confirmation: "RSE-SGP-2023-004",
    review: {
      rating: 4,
      comment:
        "Great city break! Gardens by the Bay and Marina Bay Sands were highlights.",
      date: "2023-09-18",
    },
  },
];
